import { createFileRoute } from "@tanstack/react-router";
import { ssrPage } from "@/ssr/define-page";
import { definePageMeta } from "@/ssr/define-meta";
import { Hero } from "@/components/za-terapeute/Hero";
import { Benefits } from "@/components/za-terapeute/Benefits";
import { Process } from "@/components/za-terapeute/Process";
import { Compare } from "@/components/za-terapeute/Compare";
import { Quote } from "@/components/za-terapeute/Quote";
import { FinalCta } from "@/components/za-terapeute/FinalCta";
import { PublicFaqSection } from "@/components/public/faq/PublicFaqSection";
import { buildPageStructuredData } from "@/ssr/structured-data";

const forTherapistsMeta = definePageMeta({
  titleKey: "forTherapists.meta.title",
  descriptionKey: "forTherapists.meta.description",
  ogImage: "/og-therapists.jpg",
  structuredData: (ctx) => buildPageStructuredData(ctx, {
    titleKey: "forTherapists.meta.title",
    descriptionKey: "forTherapists.meta.description",
    ogImage: "/og-therapists.jpg",
    breadcrumbs: [
      { name: "Psihotron", path: "/" },
      { name: ctx.t("nav.forTherapists"), path: "/za-terapeute" },
    ],
    mainEntity: ({ url, t }) => ({
      "@type": "Service",
      "@id": `${url.origin}/za-terapeute#therapist-platform-service`,
      name: t("forTherapists.meta.title"),
      description: t("forTherapists.meta.description"),
      serviceType: "Practice management and client discovery platform for therapists",
      provider: { "@id": `${url.origin}/#organization` },
      areaServed: {
        "@type": "Country",
        name: "Bosnia and Herzegovina",
      },
      url: `${url.origin}/za-terapeute`,
    }),
  }),
});

function ForTherapistsPage() {
  return (
    <>
      <Hero />
      <Benefits />
      <Process />
      <Compare />
      <Quote.Component />
      <PublicFaqSection.Component
        placement="therapists"
        copyKey="forTherapists.faq"
        sectionId="faq"
        background="var(--color-ther-linen)"
        flat
      />
      <FinalCta />
    </>
  );
}

export const Route = createFileRoute("/za-terapeute")(
  ssrPage({
    component: ForTherapistsPage,
    sections: [Quote, PublicFaqSection],
    meta: forTherapistsMeta,
  }),
);
